export enum DeclinationExplanationDialogFormNamesEnum {
  FORM_GROUP_NAME = 'DeclinationExplanation',
  REASON_CODE = 'ReasonCode',
  REASON_EXPLANATION = 'ReasonExplanation',
}
